import { registerTab } from "lib/@components/tabs"
import { makeLazy } from "lib/make-lazy"

const ScheduleDetails = makeLazy(() => import("./schedule-details"), "ScheduleDetails")

registerTab({ tab: "ScheduleRightBar", id: "Details", content: <ScheduleDetails priority={100} /> })
